import { CompanyActionsComponent } from '../companies/company.actions.component';
import { CompanyTypeComponent }    from '../../app-lite/companies/company.company-type.component';

export function CompaniesCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  AdminDashboard,
  API,
  chargifyApi,
  companies,
  workshopAPI
) {
  $scope.companies = companies;

  $scope.adminDashboardApi = new AdminDashboard();

  $scope.filtering = {
    value: ''
  };

  $scope.tableSettings = {
    broadcast: 'filterCompanies',
    columns  : [
      {
        field : 'company_name',
        header: {
          text: $translate.instant('COMPANY_SPACE.COMPANY')
        },
      },
      {
        field : 'email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL')
        },
      },
      {
        field : 'address1',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.ADDRESS')
        },
      },
      {
        field : 'suburb',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.SUBURB')
        },
      },
      {
        field : 'state',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATE')
        },
      },
      {
        field : 'subscription_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'companyAdminStatus',
      },
      {
        component: {
          enabled: true,
          factory: CompanyTypeComponent,
        },
        header: {
          classes: 'text-center',
          text   : $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        sortable: false
      },
      {
        component: {
          bindings: {
            outputs: {
              onAccountingClick: event => $state.go('app.manage-company', { id: event.id, tab: 'accounting' }),
              onChargifyClick  : event => $state.go('app.manage-company', { id: event.id, tab: 'chargify' }),
              onRecordsClick   : event => $state.go('app.manage-company', { id: event.id, tab: 'records' }),
              onUsersClick     : event => $scope.viewCompany(event)
            }
          },
          enabled: true,
          factory: CompanyActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: 'No Companies Found'
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/filters/count', [
        $scope.filtering.filterValue || '*',
        'companies',
        false
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'company_name'
    },
  };

  $scope.exportCancelations = function () {
    chargifyApi.exportCancelations();
  };

  $scope.freeUpUsername = function () {
    $scope.adminDashboardApi.freeUpUsername()
    .then(() => {
      $state.reload();
    });
  };

  $scope.getCompanies = ( params ) => {
    return workshopAPI.stream('/filters', [
      $scope.filtering.value || '*',
      'companies',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      false
    ])
    .then(companies => {
      $scope.companies = companies;

      return companies;
    });
  };

  $scope.viewCompany = function (company) {
    $state.go('app.manage-company', {
      id: company.id || company.row.id
    });
  };

  $scope.$watch('filtering.value', (newVal, oldVal) => {
    if (newVal !== oldVal) {
      window['filterCompanies']();
    }
  });
}
